import rocketChatService from '@/services/rocketChatService';

// get private groups (only t: "p")
export function getRoomsApi(params) {
  return rocketChatService({
    url: '/rooms',
    method: 'get',
    params
  });
}

// get room by rid
export function getRoomByRid(rid) {
  return rocketChatService({
    url: '/room',
    method: 'get',
    params: { rid }
  });
}

// create patient care room (idempotent)
export function createRoomApi(data) {
  return rocketChatService({
    url: '/room',
    method: 'post',
    data
  });
}

export function getLastSeenApi() {
  return rocketChatService({
    url: '/last-seen',
    method: 'get'
  });
}

export async function markAsReadApi(data) {
  return rocketChatService({
    url: '/last-seen',
    method: 'post',
    data
  });
}